module.exports = __webpack_public_path__ + "static/media/home-hero--bg-switzerland.c4b8e0df.jpg";